import React, { useState } from "react";
import { uploadExcel } from "./api";
import axios from "axios";
import "./App.css";

function App() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [success, setSuccess] = useState(false);

  /* 🆕 Queue state */
  const [queueMessage, setQueueMessage] = useState("");
  const [processing, setProcessing] = useState(false);

  const handleFileSelect = (e) => {
    if (processing) return; // 🔒 blocked
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      setMessage("");
      setProgress(0);
      setSuccess(false);
    }
  };

  const handleDrop = (e) => {
    if (processing) return; // 🔒 blocked
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
      setMessage("");
      setProgress(0);
      setSuccess(false);
    }
  };

  const autoHideMessage = () => {
    setTimeout(() => {
      setMessage("");
      setSuccess(false);
    }, 2000);
  };

  /* 🚀 Process Recharge Queue */
  const handleProcessQueue = async () => {
    try {
      setProcessing(true);
      setQueueMessage("⏳ Processing recharge queue...");

      const res = await axios.get("https://apis.bulk.datta-krupa.co.in/process-recharge");

      setQueueMessage(
        `✅ ${res.data.message} (Total: ${res.data.total})`
      );

      setTimeout(() => setQueueMessage(""), 3000);
    } catch (err) {
      setQueueMessage("❌ Failed to process recharge queue");
      setTimeout(() => setQueueMessage(""), 3000);
    } finally {
      setProcessing(false);
    }
  };

  const handleUpload = async () => {
    if (processing) return; // 🔒 blocked

    if (!file) {
      setMessage("⚠️ Please select an Excel file");
      autoHideMessage();
      return;
    }

    try {
      setUploading(true);
      setMessage("Uploading...");
      setSuccess(false);

      await uploadExcel(file, (e) => {
        setProgress(Math.round((e.loaded * 100) / e.total));
      });

      setMessage("✅ Uploaded successfully");
      setSuccess(true);

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (err) {
      setMessage("❌ Upload failed");
      autoHideMessage();
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="page">
      <div className="upload-card">

        {/* 🚀 PROCESS QUEUE */}
        <button
          className="process-btn"
          onClick={handleProcessQueue}
          disabled={processing || uploading}
        >
          {processing ? "Processing..." : "🚀 Process Recharge Queue"}
        </button>

        {queueMessage && (
          <p className="queue-status">{queueMessage}</p>
        )}

        <hr />

        <h2>📊 Excel Upload</h2>
        <p className="subtitle">Upload .xls or .xlsx files</p>

        <div
          className={`drop-zone ${processing ? "disabled" : ""}`}
          onDragOver={(e) => !processing && e.preventDefault()}
          onDrop={handleDrop}
        >
          <label>
            <input
              type="file"
              accept=".xlsx,.xls"
              hidden
              disabled={processing}
              onChange={handleFileSelect}
            />

            {file ? (
              <>
                <strong>{file.name}</strong>
                <span>{(file.size / 1024).toFixed(2)} KB</span>
              </>
            ) : (
              <>
                <strong>
                  {processing
                    ? "Processing queue..."
                    : "Drag & drop Excel here"}
                </strong>
                <span>
                  {processing
                    ? "Upload disabled"
                    : "or click to browse"}
                </span>
              </>
            )}
          </label>
        </div>

        <button
          onClick={handleUpload}
          disabled={uploading || processing}
        >
          {uploading ? "Uploading..." : "Upload File"}
        </button>

        {progress > 0 && !success && (
          <div className="progress-bar">
            <div style={{ width: `${progress}%` }} />
          </div>
        )}

        {success && (
          <div className="success-animation">
            <div className="checkmark">✓</div>
          </div>
        )}

        {message && <p className="status">{message}</p>}
      </div>
    </div>
  );
}

export default App;